import $ from 'jquery';
window.jQuery = $;

export default {
  init() {
    // JavaScript to be fired on all pages

    // Get references to the nav elements
    const navToggle = document.getElementById('nav-toggle');
    const navBar = document.getElementById('nav-bar');

    // Check if both elements exist
    if (navToggle && navBar) {
      // Add click event listener to the toggle button
      navToggle.addEventListener('click', function() {
        navBar.classList.toggle('is-active');
      });
    } else {
      console.warn('Nav toggle or nav bar element not found');
    }

    console.log('JS file is loading');

    // Modal System
    console.log('Modal system initializing...');

    const modal = document.getElementById('global-modal');
    if (!modal) {
      console.error('Modal #global-modal not found');
      return;
    }

    const modalTitle = modal.querySelector('.modal-title');
    const modalSubtitle = modal.querySelector('.modal-subtitle');
    const modalContent = modal.querySelector('.modal-content');
    const modalFooter = modal.querySelector('.modal-footer');
    const modalClose = modal.querySelector('.modal-close');

    console.log('Modal elements found:', {modal, modalTitle, modalSubtitle, modalContent, modalFooter, modalClose});

    if (!modalTitle || !modalSubtitle || !modalContent || !modalFooter || !modalClose) {
      console.error('Some modal elements missing');
      return;
    }

    // Function to clear modal content
    function clearModal() {
      modalTitle.innerHTML = '';
      modalSubtitle.innerHTML = '';
      modalContent.innerHTML = '';
      modalFooter.innerHTML = '';

      // Clear any custom classes from modal container
      const modalContainer = modal.querySelector('.modal-container');
      if (modalContainer) {
        modalContainer.className = 'modal-container';
      }
    }

    // Function to open modal
    function openModal(dataElement, updateHash = true) {
      console.log('Opening modal for element:', dataElement);

      // Get content from data element
      const titleEl = dataElement.querySelector('.modal-data-title');
      const subtitleEl = dataElement.querySelector('.modal-data-subtitle');
      const contentEl = dataElement.querySelector('.modal-data-content');
      const footerEl = dataElement.querySelector('.modal-data-footer');

      const title = titleEl ? titleEl.innerHTML : '';
      const subtitle = subtitleEl ? subtitleEl.innerHTML : '';
      const content = contentEl ? contentEl.innerHTML : '';
      const footer = footerEl ? footerEl.innerHTML : '';

      // Get custom class from data element
      const customClass = dataElement.getAttribute('data-modal-class') || '';

      console.log('Modal content:', {title, subtitle, content, footer, customClass});
      console.log('Raw content element:', contentEl);
      console.log('Content innerHTML length:', content.length);

      // Populate modal
      modalTitle.innerHTML = title;
      modalSubtitle.innerHTML = subtitle;

      // Handle content specially for embedded videos
      if (content.includes('iframe') || content.includes('embed') || content.includes('video')) {
        console.log('Detected embedded content, using innerHTML');
        modalContent.innerHTML = content;

        // Re-execute any scripts that might be needed for embeds
        const scripts = modalContent.querySelectorAll('script');
        scripts.forEach(script => {
          const newScript = document.createElement('script');
          newScript.textContent = script.textContent;
          if (script.src) newScript.src = script.src;
          script.parentNode.replaceChild(newScript, script);
        });
      } else {
        modalContent.innerHTML = content;
      }

      modalFooter.innerHTML = footer;

      // Apply custom class to modal container
      const modalContainer = modal.querySelector('.modal-container');
      if (modalContainer && customClass) {
        modalContainer.className = 'modal-container ' + customClass;
      }

      // Update hash if modal has a name and updateHash is true
      if (updateHash && dataElement.id && dataElement.id.startsWith('modal-data-')) {
        const modalName = dataElement.id.replace('modal-data-', '');
        console.log('Updating hash to:', modalName);
        history.pushState(null, null, '#' + modalName);
      }

      // Show modal
      modal.style.display = 'block';
      modal.classList.add('modal-opening');
      console.log('Modal displayed');

      setTimeout(() => {
        modal.classList.remove('modal-opening');
        modal.classList.add('modal-open');
      }, 50);
    }

    // Function to close modal
    function closeModal() {
      console.log('Closing modal');
      modal.classList.add('modal-closing');
      modal.classList.remove('modal-open');

      // Remove hash from URL
      if (window.location.hash) {
        history.pushState(null, null, window.location.pathname + window.location.search);
      }

      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('modal-closing');
        clearModal();
      }, 300);
    }

    // Check for hash on page load and open modal if found
    function checkHashOnLoad() {
      console.log('Checking hash on load:', window.location.hash);
      const hash = window.location.hash;
      if (hash && hash.length > 1) {
        const hashValue = hash.substring(1);
        const modalDataElement = document.getElementById('modal-data-' + hashValue);

        console.log('Looking for modal:', 'modal-data-' + hashValue, 'Found:', modalDataElement);

        if (modalDataElement) {
          setTimeout(() => {
            openModal(modalDataElement, false);
          }, 100);
        }
      }
    }

    // Event listener for modal triggers
    document.addEventListener('click', function(e) {
      console.log('Click detected on:', e.target);

      let triggerElement = e.target.closest('.modal-trigger');
      console.log('Trigger element found:', triggerElement);

      if (triggerElement) {
        console.log('Modal trigger clicked');
        e.preventDefault();
        e.stopPropagation();

        const targetId = triggerElement.getAttribute('data-modal-target');
        console.log('Target ID:', targetId);

        const dataElement = document.getElementById(targetId);
        console.log('Data element found:', dataElement);

        if (dataElement) {
          openModal(dataElement, true);
        } else {
          console.error('Data element not found for ID:', targetId);
        }
      }
    });

    // Event listeners for closing modal
    modalClose.addEventListener('click', closeModal);

    // Close on overlay click
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        closeModal();
      }
    });

    // Check for hash on page load
    checkHashOnLoad();
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};